<template>
  <v-dialog
    width="900"
    persistent
    scrollable
    v-model="isOpened"
  >
    <v-form @submit.prevent.native="$canWrite && (save($event))">
      <v-card>
        <v-card-title>
          {{ title }}
          <v-spacer />
          <v-btn icon @click="isOpened = false" v-if="!isSaving">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />

        <v-card-text class="pa-12" v-if="!hasIntervention">
          <v-progress-linear
            color="primary"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
        </v-card-text>
        <v-card-text class="pa-5" v-else>
          <v-alert
            :value="true"
            type="error"
            class="mb-6"
            v-if="errors.length"
          >
            Veuillez corriger les erreurs suivantes :
            <ul>
              <li v-for="(error, i) in errors" :key="`error${i}`">
                {{ error }}
              </li>
            </ul>
          </v-alert>
          <div class="mb-2" v-if="attachment">
            <v-label>Votre fichier</v-label>
          </div>
          <v-row class="mb-6" no-gutters align="center" justify="center" v-else>
            <v-col cols="4">
              <v-select
                :items="accountingTypes"
                v-model="type"
                item-text="label"
                item-value="id"
                label="Type de fichier"
                outlined
                hide-details
              ></v-select>
            </v-col>
            <v-col class="pl-3">
              <v-text-field v-model="accountingFilename" :label="accountingFilenameLabel" outlined hide-details />
            </v-col>
          </v-row>
          <v-row class="form-attachment mb-3" no-gutters align="center">
            <v-icon color="primary" class="ml-1">attach_file</v-icon>
            <v-col class="ml-2">
              <template v-if="file.file === null">
                <input :disabled="!$canWrite" :id="`file-input-${file.uid}`" type="file" @change="$canWrite && (loadFile(file, $event))" />
                <label :for="`file-input-${file.uid}`">{{ chooseFileLabel }}</label>
              </template>
              <v-row align="center" class="pl-2" style="font-size: 15px;" v-else>
                {{ file.file.name }}
              </v-row>
            </v-col>
            <v-btn :disabled="!$canWrite" fab icon depressed color="red" text small class="mr-0" @click="$canWrite && (removeFile())" v-if="file.file !== null">
              <v-icon>delete_outline</v-icon>
            </v-btn>
          </v-row>
          <update-comment v-model="comment" label="Votre commentaire (optionnel)" class="pa-3" />
          <!-- <update-status v-model="statusId" class="pa-3" /> -->
        </v-card-text>

        <v-divider />
        <v-card-actions>
          <v-row no-gutters justify="center" align="center" class="px-3">
            <v-spacer />
            <v-btn text @click="isOpened = false" class="mr-4" v-if="!isSaving">Annuler</v-btn>
            <v-btn :disabled="!$canWrite" type="submit" :loading="isSaving" color="primary darken-1">Enregistrer</v-btn>
          </v-row>
        </v-card-actions>

      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>

import _ from 'lodash';
import { uuid } from 'vue-uuid';
// import UpdateFiles from './Update/Files.vue';
import UpdateComment from './Update/Comment.vue';
// import UpdateStatus from './Update/Status.vue';

export default {
  name: `InterventionAddFile`,
  props: {
    intervention: Object,
    attachment: Boolean,
  },
  data: () => ({
    isOpened: true,
    isSaving: false,
    errors: [],
    files: [],
    comment: ``,
    statusId: null,
    file: null,
    type: 0,
    accountingTypes: [
      { id: 1, label: `Devis` },
      { id: 2, label: `Facture` },
    ],
    accountingFilename: ``,
  }),
  computed: {
    hasIntervention() {
      return this.intervention && this.intervention !== null;
    },
    title() {
      return `Ajouter ${this.attachment ? `une pièce jointe` : `un devis / facture`}`;
    },
    accountingFilenameLabel() {
      return `Votre numéro de ${this.type === 1 ? `devis` : `facture`}*`;
    },
    chooseFileLabel() {
      return `Choisissez un fichier ${this.attachment ? `` : `(PDF)`}`;
    },
  },
  methods: {
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(
          reader.result.replace(/^[^,]+,/g, ``)
        );
        reader.onerror = error => reject(error);
      });
    },
    async loadFile(file, event) {
      const fileObj = event.target.files[0];
      const pdfErrorMessage = `Merci de sélectioner un fichier au format PDF`;

      const errorMessageIndex = this.errors.indexOf(pdfErrorMessage);
      if (errorMessageIndex !== -1) {
        this.errors.splice(errorMessageIndex, 1);
      }

      if (!this.attachment && fileObj.type !== `application/pdf`) {
        this.errors.push(pdfErrorMessage);
        return;
      }

      file.file = fileObj;
      file.fileBase64 = await this.fileToBase64(file.file);
    },
    removeFile() {
      this.file.file = null;
      this.file.fileBase64 = null;
    },
    async save() {
      this.errors = [];
      if (!this.file.file) { this.errors.push(`Veuillez choisir un fichier`); }
      if (!this.attachment && !this.accountingFilename) { this.errors.push(`Veuillez saisir le numéro de votre document`); }
      if (!this.errors.length) {
        this.comment = _.trim(this.comment);
        this.isSaving = true;
        let filename = this.file.file.name;
        let mimeType = this.file.file.type;
        if (!this.attachment) {
          filename = `${this.accountingFilename}.pdf`;
          mimeType = `application/pdf`;
        }
        try {
          const file = await this.$store.dispatch(`model/file/addFile`, {
            type: this.type,
            interventionId: this.intervention.id,
            filename,
            mimeType,
            content: this.file.fileBase64,
            description: this.comment,
          });
          this.$emit(`added`, file);
        } catch (e) {
          this.$store.dispatch(`showSnackbar`, {
            color: `error`,
            message: `Impossible d'ajouter ce fichier, réessayez`,
          });
        }
        this.isSaving = false;
      }
    },
  },
  beforeMount() {
    if (this.hasIntervention) {
      this.statusId = this.intervention.status.id;
    }
    if (!this.attachment) {
      this.type = this.accountingTypes[0].id;
    }
    this.file = {
      uid: uuid.v4(),
      file: null,
      fileBase64: null,
    };
  },
  watch: {
    isOpened(isOpened) {
      if (!isOpened) {
        this.$emit(`close`);
      }
    },
    hasIntervention(hasIntervention) {
      if (hasIntervention) {
        this.statusId = this.intervention.status.id;
      }
    },
  },
  components: {
    UpdateComment,
    // UpdateStatus,
  },
};
</script>

<style lang="scss" scoped>
  .form-attachment [type="file"] {
    border: 0;
    clip: rect(0, 0, 0, 0);
    height: 1px;
    overflow: hidden;
    padding: 0;
    position: absolute !important;
    white-space: nowrap;
    width: 1px;
  }

  .form-attachment [type="file"] + label {
    background-color: #FFF;
    border: 2px solid #444;
    border-radius: 4px;
    color: #222;
    cursor: pointer;
    display: inline-block;
    padding: 5px 40px;
  }

  .form-attachment [type="file"]:focus + label,
  .form-attachment [type="file"] + label:hover {
    background-color: $primaryColor;
    color: #FFF;
  }

  .form-attachment [type="file"]:focus + label {
    outline: 1px dotted #000;
  }
</style>
